








































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'
import { SearchProjectOptions, SearchResult, SearchTeamMemberOptions, Service, TeamMember } from '@/models'
import { Utils } from '@/utils'

interface ServiceMap {
  [index: string]: Service;
}

@Component({
  name: 'Project',
  components: {
    ProductsTable: () => import('@/components/ProductsTable.vue'),
    ProductServicesList: () => import('@/components/ProductServicesList.vue')
  }
})
export default class Project extends Vue {
  private projects: SearchResult = { items: [], pageOffset: 0, pageSize: 0, totalResults: 0 }
  private projectServices: ServiceMap = {}
  private services: Service[] = []
  private teamMembers: TeamMember[] = []
  private accordionState = []

  private years: Array<number> = Utils.getYearsForCampaign(2019)
  private filters = {
    name: null,
    year: '',
    service: 0,
    team: ''
  }

  private defaultPageSize = 10
  private currentPage = 1
  private loadingProjects = false

  private delayLoadProjects = Utils.delay(this.loadProjects, 500)

  @Watch('currentPage')
  onCurrentPageChanged(value: string, oldValue: string) {
    if (value !== oldValue) {
      this.loadProjects()
    }
  }

  @Watch('filters', { deep: true })
  onFiltersChanged() {
    this.delayLoadProjects.apply(this)
  }

  created() {
    this.loadProjects()
    this.loadServices()
    this.loadTeamMembers()
  }

  private async loadProjects() {
    this.loadingProjects = true
    this.closeAllAccordionState()
    try {
      const searchOptions: SearchProjectOptions = {
        name: this.filters.year + '%' + (this.filters.name ? this.filters.name : ''),
        service: this.filters.service ? this.filters.service : null,
        team: this.filters.team ? this.filters.team : null,
        offset: (this.currentPage - 1) * this.defaultPageSize,
        limit: this.defaultPageSize
      }
      const response = await ApiClient.searchProjects(searchOptions)
      if (response.totalResults < response.pageOffset) {
        this.currentPage = 1
      }
      this.projects = Object.assign({}, this.projects, response)
      this.loadingProjects = false
    } catch (error) {
      this.loadingProjects = false
    }
  }

  private async lazyLoadProjectServices(projectCode: string) {
    if (!this.projectServices[projectCode]) {
      const projectServices = await ApiClient.getProjectServices(projectCode)
      Vue.set(this.projectServices, projectCode, projectServices)
    }
  }

  private async loadServices() {
    const response = await ApiClient.getServices()
    this.services = Object.assign({}, this.services, response.filter((item) => item.enabled))
  }

  private async loadTeamMembers() {
    const searchOptions: SearchTeamMemberOptions = {
      type: ''
    }
    const response = await ApiClient.getTeamMembers(searchOptions)
    this.teamMembers = Object.assign({}, this.teamMembers, response)
  }

  private show(projectCode: string) {
    Vue.set(this.accordionState, projectCode, true)
    this.lazyLoadProjectServices(projectCode)
  }

  private hide(projectCode: string) {
    Vue.set(this.accordionState, projectCode, false)
  }

  private closeAllAccordionState() {
    for (const key in this.accordionState) {
      Vue.set(this.accordionState, key, false)
    }
  }

  private resetFilters() {
    Vue.set(this.filters, 'name', null)
    Vue.set(this.filters, 'service', 0)
    Vue.set(this.filters, 'team', '')
    Vue.set(this.filters, 'year', '')
  }

  private filterByTeam(team: TeamMember) {
    this.resetFilters()
    this.filters.team = team.email
  }
}
